
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue'
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import contactInfo from "@/apps/shared/components/ContactInfo.vue";
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import localityService from '@/apps/shared/services/locality-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'tabOne',
        components: {
            XBreadcrumb,
            contactInfo,
            TitleAndPromotions,
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "Accidentes Personales en Ocasión de Trabajo o Actividad",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos",
                    product: "AP Ocasion de Trabajo",
                    icon: {
                        src: '/logos/AP_OT.svg',
                        alt: 'AP Ocasion de Trabajo',
                        title: 'AP Ocasion de Trabajo'
                    },
                    iconPromotion: {
                        src: '/icons/hotweek-logo.png',
                        alt: 'logoHotWeek',
                        title: 'HotWeek'
                    },
                    otherIconPromotion: {
                        src: '/icons/cybermonday.svg',
                        alt: 'logoCiberMonday',
                        title: 'CiberMonday'
                    },
                } as TitleAndPromotionsDetails,
                validatePhone: false,
                validLastName: false,
                lastName: '',
                telephone: '',
                areaCode: '',
                email: '',
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                selectedLocality: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                discountRate: null,
                fechaPromotions: null,
                responseDiscountRange: null,
                containDiscountRange: false,
                changeTitlePromotions: false,
                sendDataDiscount: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/ocasion-de-trabajo' },
                    { text: 'Datos Personales', path: '/ocasion-de-trabajo/' },
                ],
                referente: null,
                medium: null,
            }
        },

        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },

        methods: {
            async pageCustomization() {
                const defaultTitle = 'Ocasión de Trabajo';
                const actualPath = '/ocasion-de-trabajo';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultAPTrabajoGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            comenzar() {
                const contactInfoRef = this.$refs.contactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                this.validatePhone = false;
                const { email, telephone, areaCode, validTelephone, validEmail } = contactInfoRef;
                this.email = email;
                this.telephone = telephone;
                this.areaCode = areaCode;
                this.validatePhone = validTelephone;
                this.validLastName = this.lastName != '';
                const validateEmail = validEmail;

                sessionStorage.removeItem("productId");
                sessionStorage.setItem("productId", "555");

                if (this.validLastName && this.validatePhone && validateEmail && this.selectedLocality) {
                    NF.UI.Page.block();
                    //------------------------------------------------------------
                    return new Promise<any>(async (resolve) => {
                        CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, this.areaCode, this.telephone, 555, false, "1", null, this.lastName, null).then((response) => {
                            var dataTomador = {
                                name: "",
                                lastName: this.lastName,
                                areaCode: this.areaCode,
                                telephone: this.telephone,
                                email: this.email,
                                selectedLocality: this.selectedLocality,
                                hasDiscount: this.containDiscountRange,
                                discount: this.responseDiscountRange,
                            }
                            resolve(true);
                            sessionStorage.setItem("LeadId", JSON.stringify(response));
                            //window.globalThis.dataLayer.push({ 'product': 'Ocasión-de-Trabajo', 'event': 'ocassion-of-work-tab-One' });
                            sessionStorage.removeItem("TabOneWelcome");
                            sessionStorage.setItem("TabOneWelcome", JSON.stringify(dataTomador));

                            this.$router.push({
                                name: 'ocassion-of-work-tab-two',
                            })
                        });
                    })
                    //------------------------------------------------------------
                } else {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': null,
                        'product': 'aptrabajo',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-aptrabajo-view',
                        'referente': this.referente,
                        'medio': this.medium
                    });

                }
            },
            RedirectToHome() {
                let urlParams = new URLSearchParams(window.location.search);
                let parameter = urlParams.get('test');
                if (parameter == null) {
                    window.location.href = "https://www.sancorseguros.com.ar/";
                }
            },
        },

        async mounted() {
            NF.UI.Page.block();
            //this.RedirectToHome();

            await this.pageCustomization();

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            this.updateByProductGoogleAnalytics();
            window.globalThis.dataLayer.push({
                'pas': null,
                'email': null,
                'product': 'aptrabajo',
                'event': 'cotizador-aptrabajo-view',
                'referente': this.referente,
                'medio': this.medium
            });
            new Promise<any>(async (resolve) => {
                DiscountRangeService.getWorkOcassionDiscountRange().then((response) => {
                    this.containDiscountRange = response.length > 0;
                    if (this.containDiscountRange) {
                        this.responseDiscountRange = response;
                        this.discountRate = this.responseDiscountRange[0].discountMaxValue;
                        this.fechaPromotions = new Date();
                        const FechaInicioEvento = new Date("2024-05-16");
                        const FechaFinEvento = new Date("2024-05-19");
                        this.changeTitlePromotions = (this.fechaPromotions >= FechaInicioEvento && this.fechaPromotions <= FechaFinEvento);
                    }
                    this.sendDataDiscount = {
                        discountRate: this.discountRate,
                        containDiscountRange: this.containDiscountRange,
                        changeTitlePromotions: this.changeTitlePromotions,
                    };
                });
                NF.UI.Page.unblock();
                this.$refs.titlesAndPromotions.setDiscountData(this.sendDataDiscount);
                resolve(true);
            });
            sessionStorage.clear();
            sessionStorage.setItem("Referente", this.referente);
            sessionStorage.setItem("Medium", this.medium);
        }
    })
